import { axiosInstanceTasks } from "../axios";
import { AppConfigCreate, AppConfiguration, RequestResponse } from "../types";

export const createAppConfig: (
  payload: AppConfigCreate
) => Promise<RequestResponse> = async (payload) => {
  try {
    await axiosInstanceTasks.post("/app-configs", payload);
    return {
      error: false,
      data: null,
    };
  } catch (err) {
    console.error("Unable to create app config: ", { err });
    return {
      error: true,
      message: err.response?.data?.error_description?.includes(
        "Access is denied"
      )
        ? "Access denied: You do not have permission to perform this activity."
        : err.response?.data?.error_description ||
          err.response?.data?.message ||
          err.message ||
          err,
      data: null,
    };
  }
};

export const getAppConfig: (
  pageNumber: number
) => Promise<RequestResponse<{ records: AppConfiguration[]; total: number }>> =
  async (pageNumber) => {
    try {
      const response = await axiosInstanceTasks.get("/app-configs", {
        params: { page: pageNumber },
      });

      return {
        error: false,
        data: {
          records: response.data.data.records,
          total: response.data.data.total,
        },
      };
    } catch (err) {
      console.error("Unable to fetch app configs: ", { err });
      return {
        error: true,
        message: err.response?.data?.error_description?.includes(
          "Access is denied"
        )
          ? "Access denied: You do not have permission to perform this activity."
          : err.response?.data?.error_description ||
            err.response?.data?.message ||
            err.message ||
            err,
        data: null,
      };
    }
  };

export const updateAppConfig = async (
  id: number,
  payload: AppConfigCreate
): Promise<RequestResponse> => {
  try {
    await axiosInstanceTasks.put(`/app-configs/${id}`, payload);
    return {
      error: false,
      data: null,
    };
  } catch (err) {
    console.error("Unable to update app config: ", { err });
    return {
      error: true,
      message: err.response?.data?.error_description?.includes(
        "Access is denied"
      )
        ? "Access denied: You do not have permission to perform this activity."
        : err.response?.data?.error_description ||
          err.response?.data?.message ||
          err.messag ||
          err,
      data: null,
    };
  }
};

export const getAppConfigByModuleName = async (
  moduleName: string,
  pageNumber: number,
  pageSize: number
): Promise<RequestResponse<{ records: AppConfiguration[]; total: number }>> => {
  try {
    const response = await axiosInstanceTasks.get(
      `/app-configs/by-module-name/${moduleName}`,
      {
        params: { page: pageNumber, size: pageSize },
      }
    );

    return {
      error: false,
      data: {
        records: response.data.data.records,
        total: response.data.data.total,
      },
    };
  } catch (err) {
    console.error("Unable to fetch app configs by module name: ", { err });
    return {
      error: true,
      message: err.response?.data?.error_description?.includes(
        "Access is denied"
      )
        ? "Access denied: You do not have permission to perform this activity."
        : err.response?.data?.error_description ||
          err.response?.data?.message ||
          err.message ||
          err,
      data: null,
    };
  }
};
